import ListingVM from './listing-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(ele) {
    console.log('InstructorBadgesListingVM initialization function called');
    const listingVM = new Vue(ListingVM);
    console.log(ele.dataset);
    listingVM.$mount(ele);
    listingVM.bindData(JSON.parse(ele.dataset.badges), ele.dataset.page);
  }
};

